module.exports = __webpack_public_path__ + "static/media/fsyuce020.d75202dd.jpg";